import React from "react"
import * as types from "Functions/propTypes"
import { Redirect } from "react-router-dom"
import { URI_LIST } from "constructs"

const ErrorHandling = ({ useHandle, children }) => useHandle ? <Redirect to={URI_LIST.index} /> : children

ErrorHandling.propTypes = types.ErrorHandling

export default ErrorHandling